import { Code } from '@/lib/mockCodes';

export interface CoalitionCandidate {
  cod_collegioP: string;
  desc_collegioP: string;
  cod_lis: string;
  cod_cand: string;
  cognome: string;
  nome: string;
  a_nome: string;
  sex: string;
  d_nasc: string;
  l_nasc: string;
  eletto: string;
}

export interface Coalition {
  logo: string;
  candidates: CoalitionCandidate[];
}

export interface Candidate {
  fullName: string;
  partyName: string;
  fillColor: string;
  coalitions: Coalition[];
  position: number;
}

export interface ChartResult {
  label?: string;
  code: Code;
  result: number;
}

export interface Chart extends ChartResult {
  fillColor: string;
  innerResults?: ChartResult[];
}

export interface MapSettings {
  coordinates: number[];
  sourceId: string;
  sourceUrl: string;
  layerId: string;
  sourceLayer: string;
  featureId: number;
}

export interface Structure {
  fillColor: string;
  tabLabel: string;
  collegeName: string;
  candidates: Candidate[];
  mapSettings: MapSettings;
  prevElectionChart: Chart[];
  demographicDesc: string;
  demographicVars: VariableModel[];
}

export interface ResultsModel {
  cityName: string;
  fullAddress: string;
  structures: Structure[];
}

export interface VariableModel {
  code: Code;
  label: string;
  description: string;
  frontBarLabel: string;
  frontBarPercentage: number;
  backBarLabel: string;
  backBarPercentage: number;
}

export enum StructureType {
  SENATE,
  CAMERA,
}
